/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
// libraries
import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import LazyLoad from 'react-lazyload';
import { useUIDSeed } from 'react-uid';
import { Modal } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import {
    array, func, object, string, bool,
} from 'prop-types';
import ProductImageModalStyle from './ProductImageModalStyle';
import Helper from '../../../../../pages/Account/state/reducers/Helper';

const ProductImageModal = (props) => {
    const {
        hideProductModal, classes, modalSize, showModal, productName, path, name, additionalImages, settings,
    } = props;
    let poductImage = [name];
    poductImage = poductImage.concat(additionalImages);
    const [zoomed, setZoomed] = useState(true);
    const [dbClickEnabled, setDBClickEnabled] = useState(true);
    useEffect(() => {
        setZoomed(true);
        setDBClickEnabled(true);
    }, []);
    /* eslint-disable react/jsx-props-no-spreading */
    const seed = useUIDSeed();
    const modalContainerSize = () => {
        switch (modalSize) {
            case 'sm':
                return `${classes.modalContainer} ${classes.modalSm}`;
            case 'md':
                return `${classes.modalContainer} ${classes.modalMd}`;
            case 'lg':
                return `${classes.modalContainer} ${classes.modalLg}`;
            default:
                return classes.modalContainer;
        }
    };
    const zoomDetector = () => {
        setTimeout(() => {
            const getData = Helper.getSessionStorageObject('store-zoom-scale');
            if (getData !== 1) setZoomed(false);
            else setZoomed(true);
        }, 200);
    };

    return (
        <div>
            <div>
                <Modal id="modalWrapper" open={showModal} onClose={hideProductModal} className={classes.modal}>
                    <div className={modalContainerSize()}>
                        <h1 className={classes.alignTextLeft}>
                            <span className={classes.right} onClick={() => hideProductModal()} onKeyDown={() => { }} role="button" tabIndex={-1}> <CloseIcon /></span>
                        </h1>
                        <div className={classes.modalBody}>
                            <Slider
                                {...settings}
                                className={classes.plantsSliderContainer}
                            >
                                {poductImage?.map((img) => (
                                    <TransformWrapper
                                        pan={{
                                            lockAxisX: !!zoomed,
                                            lockAxisY: !!zoomed,
                                        }}
                                        defaultScale={1}
                                        defaultPositionX={100}
                                        defaultPositionY={100}
                                        dir="ltr"
                                        doubleClick={{
                                            disabled: !dbClickEnabled,
                                            step: 40,
                                        }}
                                        key={`${path}${img}x.jpg`}
                                        options={{
                                            maxScale: 4,
                                        }}
                                        onZoomChange={() => zoomDetector()}
                                    >
                                        {({
                                            scale,
                                        }) => (
                                            <>
                                                {Helper.setSessionStorageObject('store-zoom-scale', scale)}
                                                <TransformComponent>
                                                    <LazyLoad key={seed(img)}>
                                                        <img
                                                            className={`${classes.slide} ${classes.plantsSlide}`}
                                                            src={`${path}${img}x.jpg`}
                                                            alt={productName || 'Plants'}
                                                            dir="ltr"
                                                        />
                                                    </LazyLoad>
                                                </TransformComponent>
                                            </>
                                        )}
                                    </TransformWrapper>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </Modal>
            </div>
        </div>

    );
};
ProductImageModal.propTypes = {
    classes: object.isRequired,
    productName: string.isRequired,
    path: string.isRequired,
    name: string.isRequired,
    additionalImages: array.isRequired,
    hideProductModal: func.isRequired,
    settings: object.isRequired,
    showModal: bool,
    modalSize: string,
};
ProductImageModal.defaultProps = {
    showModal: true,
    modalSize: 'small',
};

export default withStyles(ProductImageModalStyle)(ProductImageModal);
